// import "react-app-polyfill/ie11"; // For IE 11 support
import "react-app-polyfill/stable";
import React, { Suspense } from "react";
import { SpeedInsights } from "@vercel/speed-insights/react";
// import { Analytics } from "@vercel/analytics/react"
import "./polyfill";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import App from "./App";
// Service worker registration

const ErrorPage = React.lazy(() => import("./components/errors/ErrorPage"));

const container = document.getElementById("root");
const root = createRoot(container);

function getErrorPage(error) {
  return (
    <Suspense fallback={<></>}>
      <ErrorPage error={error?.error} />
    </Suspense>
  );
}

const logError = (error: Error, info: { componentStack: string }) => {
  console.log("ERROR", error, info.componentStack);
};

root.render(
  // <React.StrictMode>
  <>
    {/* <Analytics /> */}
    <ErrorBoundary FallbackComponent={getErrorPage} onError={logError}>
      <App />
    </ErrorBoundary>
    <SpeedInsights />
  </>,
  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// Register the service worker
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/progressier.js')
//       .then(registration => {
//         console.log('Service Worker registered with scope:', registration.scope);
//       })
//       .catch(error => {
//         console.error('Service Worker registration failed:', error);
//       });
//   });
// }
